import { UserDefinedRow } from "../../model";
import { UsecaseValidationMessage } from "../UsecaseValidationMessage";
import { BaseUsecaseLogic } from "../BaseUsecaseLogic";
import { Dates } from "../../util";

/** Client-side logic for Absence period as UserDefined row (in calculation).  */
export class HolidaysUsecaseLogic extends BaseUsecaseLogic {
  protected getUcValidation(_row: UserDefinedRow): UsecaseValidationMessage | undefined {
    return undefined;
  }
  /**
   * Updates the workdays count
   * @param row Current row that is being edited.
   */
  public updatePeriodDays(row: any): void {
    if (!row.period) {
      return;
    }
    if (row.period.start > row.period.end) {
      row.period.end = row.period.start;
    }
    if (row.period.start && row.period.end) {
      if (row.period.days) {
        row.period.days = Dates.getWorkdays(row.period.start, row.period.end);
        row.period.daysCount = row.period.days.length;
      } else {
        row.period.daysCount = Dates.getWorkdays(row.period.start, row.period.end).length;
      }
    }
  }

  /**
   * Sets the days array in period to enable days selection UI.
   * @param row Current row that is being edited.
   */
  public setDaysSelection(row: any): void {
    row.period.days = Dates.getVacationDays(row.period.start, row.period.end);
    row.period.daysCount = row.period.days.length;
  }

}
